import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { themeConfig } from 'configs/theme.config'

// Boş resources ile başlat
const resources = {}

// Varsayılan dili TR olarak ayarla
const defaultLocale = 'tr'

i18n.use(initReactI18next).init({
    resources,
    fallbackLng: defaultLocale,
    lng: defaultLocale,
    interpolation: {
        escapeValue: false 
    }
})

// Tarih yerelleştirmeleri için dinamik yükleme işlevi
export const dateLocales = {
    tr: () => import('dayjs/locale/tr'),
    en: () => import('dayjs/locale/en'),
}

// Çevirileri dinamik olarak güncellemek için yardımcı fonksiyon
export const updateTranslations = (langCode, translations) => {
    // Çevirileri key-value formatına dönüştürme
    const translationData = {};
    translations.forEach(item => {
        translationData[item.key] = item.value;
    });

    // Yeni dil kaynağını i18n'e ekle/güncelle
    const code = langCode.split('-')[0].toLowerCase(); // 'tr-TR' -> 'tr'
    
    if (!i18n.hasResourceBundle(code, 'translation')) {
        i18n.addResourceBundle(code, 'translation', translationData);
    } else {
        // Mevcut çevirileri koruyarak yenileri ekle
        const currentTranslations = i18n.getResourceBundle(code, 'translation');
        i18n.addResourceBundle(
            code, 
            'translation', 
            { ...currentTranslations, ...translationData }, 
            true, 
            true
        );
    }
    return code;
};

export default i18n